import { B as BxfTextInputConstants } from './p-57102994.js';
import { h } from './p-06a8959f.js';
import { O as WindowEventMap, w as getKeyboardFocusCSS } from './p-0856cfca.js';
import { F as FocusIndexManager } from './p-8b298ca7.js';
import { A as AriaAttr } from './p-d7c3b756.js';

const { CLEAR_ICON, CLEAR_ICON_HIDDEN, CLEAR_BUTTON_LABEL, CLEAR_ICON_ID, CLEAR_BUTTON_DISABLED, } = BxfTextInputConstants.STRING;
class BxfTextInputClear {
    delegate;
    isInputFocused = false;
    constructor(delegate) {
        this.delegate = delegate;
        this.onKeyUpHandler = this.onKeyUpHandler.bind(this);
        this.onFocusHandler = this.onFocusHandler.bind(this);
        this.onBlurHandler = this.onBlurHandler.bind(this);
        // `inputRef` *must* be defined
        this.delegate.inputRef.addEventListener(WindowEventMap.keyup, this.onKeyUpHandler);
        this.delegate.inputRef.addEventListener(WindowEventMap.focus, this.onFocusHandler);
        this.delegate.inputRef.addEventListener(WindowEventMap.blur, this.onBlurHandler);
        this.clear = this.clear.bind(this);
        this.buttonKeyDownHandler = this.buttonKeyDownHandler.bind(this);
    }
    onKeyUpHandler() {
        this.focusHandler(true);
    }
    onFocusHandler(event) {
        this.focusHandler(true, event);
    }
    onBlurHandler(event) {
        this.focusHandler(false, event);
    }
    /**
     * On enter/space - stop event propagation to prevent typeahead enter from being triggered
     */
    buttonKeyDownHandler(event) {
        if (FocusIndexManager.PRESS_KEYS.includes(event.key)) {
            event.stopPropagation();
        }
    }
    focusHandler(isFocused, event) {
        this.isInputFocused = isFocused;
        if (this.delegate.clearDidChangeFocus) {
            this.delegate.clearDidChangeFocus(isFocused, event);
        }
    }
    clear(event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.delegate.inputRef.value = '';
        this.focusHandler(true, event);
        if (this.delegate.didClear) {
            this.delegate.didClear(event);
        }
    }
    shouldDisplayIcon(onFocus) {
        return onFocus
            ? `${this.delegate.inputRef.value}`.length > 0 &&
                this.isInputFocused
            : `${this.delegate.inputRef.value}`.length > 0;
    }
    getIconContainerClass(forceDisplay, onFocus, isReadOnly, clearButtonLabel) {
        const shouldDisplay = (forceDisplay || this.shouldDisplayIcon(onFocus)) && !isReadOnly;
        const initialCss = `${CLEAR_ICON} ${shouldDisplay ? '' : CLEAR_ICON_HIDDEN} ${this.delegate.isDisabled ? CLEAR_BUTTON_DISABLED : ''}`;
        return {
            class: getKeyboardFocusCSS(initialCss, this.delegate.keepMouseFocus),
            disabled: this.delegate.isDisabled,
            onClick: this.clear,
            onFocus: this.onFocusHandler,
            onBlur: this.onBlurHandler,
            onKeyDown: this.buttonKeyDownHandler,
            [AriaAttr.HIDDEN]: shouldDisplay ? null : 'true',
            [AriaAttr.LABEL]: clearButtonLabel,
            tabIndex: shouldDisplay ? 0 : -1,
        };
    }
    destroy() {
        if (this.delegate && this.delegate.inputRef) {
            this.delegate.inputRef.removeEventListener(WindowEventMap.keyup, this.onKeyUpHandler);
            this.delegate.inputRef.removeEventListener(WindowEventMap.focus, this.onFocusHandler);
            this.delegate.inputRef.removeEventListener(WindowEventMap.blur, this.onBlurHandler);
        }
    }
    render(forceDisplay, onFocus, isReadOnly, clearButtonLabel = CLEAR_BUTTON_LABEL) {
        return (h("button", { "data-bxf-id": CLEAR_ICON_ID, ...this.getIconContainerClass(forceDisplay, onFocus, isReadOnly, clearButtonLabel) },
            h("bxf-icon", { type: 'clear', state: 'secondary', isDisabled: this.delegate.isDisabled })));
    }
}

export { BxfTextInputClear as B };
